import React from "react";

import { GuaranteedIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { GuaranteedWrapper } from "src/organization/pages/project/environment/metrics/components/tooltip/style";

type MaxCpuProps = {
  cpuNumber: string;
  isGuaranteed: boolean;
};
const MaxCpu = ({ cpuNumber, isGuaranteed }: MaxCpuProps) => {
  const intl = useIntl();
  const baseFormat = `${cpuNumber} ${intl.formatMessage({ id: "cpu_dialog" })}`;
  return isGuaranteed ? (
    <GuaranteedWrapper>
      <span>{baseFormat}</span>
      <GuaranteedIcon />
    </GuaranteedWrapper>
  ) : (
    baseFormat
  );
};

export default MaxCpu;
